import React from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Package, Users, Settings as SettingsIcon, LogOut, Sparkles, MessageSquareQuote, HelpCircle, Home, Tags, Warehouse } from 'lucide-react';
import { Button } from '../components/ui/button';

const NAV = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/admin/products', icon: Package, label: 'Productos' },
  { to: '/admin/stock', icon: Warehouse, label: 'Stock' },
  { to: '/admin/categories', icon: Tags, label: 'Categorías' },
  { to: '/admin/testimonials', icon: MessageSquareQuote, label: 'Opiniones' },
  { to: '/admin/faqs', icon: HelpCircle, label: 'FAQs' },
  { to: '/admin/users', icon: Users, label: 'Administradores' },
  { to: '/admin/settings', icon: SettingsIcon, label: 'Ajustes' },
];

export default function AdminLayout() {
  const { user, logout, loading } = useAuth();
  const nav = useNavigate();

  React.useEffect(() => {
    if (!loading && !user) nav('/admin/login');
  }, [user, loading, nav]);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando…</div>;
  if (!user) return null;

  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="admin-layout">
      <aside className="w-64 bg-white border-r border-slate-200 flex flex-col sticky top-0 h-screen">
        <div className="h-20 flex items-center gap-2 px-6 border-b border-slate-200">
          <Sparkles className="h-6 w-6 text-pinky-500" />
          <span className="font-display text-xl text-slate-900">Gifts GT</span>
        </div>
        <nav className="flex-1 px-3 py-5 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-colors ${
                  isActive ? 'bg-pinky-50 text-pinky-600' : 'text-slate-600 hover:bg-slate-100'
                }`
              }
            >
              <n.icon className="h-4 w-4" strokeWidth={1.8} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-200 space-y-2">
          <Link to="/" className="flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold text-slate-600 hover:bg-slate-100" data-testid="admin-view-site">
            <Home className="h-4 w-4" /> Ver sitio
          </Link>
          <div className="px-3 py-2 text-xs text-slate-500">Sesión: <span className="font-semibold text-slate-800">{user.username}</span></div>
          <Button
            data-testid="admin-logout"
            variant="outline"
            onClick={async () => { await logout(); nav('/admin/login'); }}
            className="w-full rounded-xl gap-2"
          >
            <LogOut className="h-4 w-4" /> Cerrar sesión
          </Button>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
